import { useEffect, useMemo, useState } from 'react';
import { CustomButton, InputSelect } from 'shared_ui_components';
import classes from './QualifyingCriteria.module.css';
import { useUpdatePassingCriteriaMutation } from 'features/settings/components/QualifyingCriteria/QualifiyingCriteria.queries';

const defaultOpt = { value: 70, label: '70%' };

const QualifyingCriteriaConfigV2 = ({ data, isLoading }) => {
  const [moduleCriteria, setModuleCriteria] = useState({ value: '', label: 'Loading...' });

  useEffect(() => {
    if (isLoading) return;
    const value = data?.module_assessments?.rating_to_qualify || 70;
    if (value) setModuleCriteria({ value, label: `${value}%` });
  }, [data, isLoading]);

  const options = useMemo(() => {
    const opts = [];
    let value = 5;
    do {
      opts.push({ value, label: `${value}%` });
      value += 5;
    } while (value <= 100);
    return opts;
  }, []);

  const criterion_uuid = useMemo(() => {
    if (!data) return '';
    return data?.module_assessments?.uuid;
  }, [data]);

  const onModuleCriteriaChange = (opt) => setModuleCriteria(opt);
  const resetModule = () => setModuleCriteria(defaultOpt);

  const { mutate } = useUpdatePassingCriteriaMutation();
  const onSubmit = () => mutate({ criterion_uuid, min_value: moduleCriteria?.value });

  return (
    <div className={classes.containerV2}>
      <div className={classes.cardV2}>
        <h1>Module Quizzes</h1>
        <p>Rating to qualify</p>
        <InputSelect
          disabled={isLoading}
          value={moduleCriteria}
          onChange={onModuleCriteriaChange}
          options={options}
        />
        <div className={classes.buttonsContainer}>
          <button type="button" onClick={resetModule} className={classes.reset}>
            Reset to default
          </button>
          <CustomButton onClick={onSubmit}>Save</CustomButton>
        </div>
      </div>
    </div>
  );
};

export default QualifyingCriteriaConfigV2;
